import { ElementRef } from '@angular/core';
import { GoogleMapOptions, GoogleMaps, GoogleMapsEvent, GoogleMapsMapTypeId, ILatLng } from '@ionic-native/google-maps';
import { MapOptions } from './map-options';
import { MapWrapper } from './map-wrapper';


export class MapUtil {

    static create(mapElement: ElementRef, mapOptions?: MapOptions): MapWrapper {
        let options: GoogleMapOptions = MapUtil.getDefaultMapOptions();

        if (mapOptions) {
            if (mapOptions.disable) {
                options.gestures = {
                    rotate: false,
                    zoom: false,
                    scroll: false,
                    tilt: false
                };
                options.controls = {
                    compass: false,
                    myLocationButton: false,
                    myLocation: false
                };
            }
        }

        const map = GoogleMaps.create(mapElement.nativeElement, options);
        map.setOptions(mapOptions);
        if (mapOptions && mapOptions.onclick) {
            map.on(GoogleMapsEvent.MAP_CLICK)
                .subscribe((location: ILatLng) => {
                    mapOptions.onclick(location);
                });
        }

        return new MapWrapper(map);
    }

    private static getDefaultMapOptions(): GoogleMapOptions {
        return {
            mapType: GoogleMapsMapTypeId.HYBRID,
            camera: {
                zoom: 16
            },
            controls: {
                compass: true,
                myLocation: true,
                myLocationButton: false
            },
            gestures: {
                rotate: true
            }
        };
    }
}